<template>
    <div class="space-course wrapper">
        <proTitle></proTitle>
        <el-form :inline="true" :model="formInline" class="demo-form-inline flex-align-between" @submit.native.prevent>
            <div class="formInline-left">
                <el-form-item>
                    <el-input v-model="formInline.search" size="small" clearable placeholder="搜索空间/课程名称"
                        suffix-icon="el-icon-search" style="width: 240px;" />
                </el-form-item>
                <el-form-item>
                    <el-select v-model="formInline.spxId" size="small" clearable filterable placeholder="按空间筛选"
                        style="width: 200px;" @change="filterChange">
                        <el-option label="全部空间" value="" />
                        <el-option v-for="item in spaceOptions" :key="item.id" :label="item.spxName" :value="item.id" />
                    </el-select>
                </el-form-item>
            </div>
            <div class="formInline-right">
                <el-form-item>
                    <el-button type="primary" size="small" icon="el-icon-download"
                        @click="exportExcelFile">导出为Excel</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" icon="el-icon-download"
                        @click="exportWordFile">导出为Word</el-button>
                </el-form-item>
            </div>
        </el-form>

        <div class="table_section">
            <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" :span-method="objectSpanMethod">
                <el-table-column type="index" label="序号" width="80" align="center" :index="indexMethod" />
                <el-table-column prop="spaceName" label="空间名称" align="center" min-width="160" show-overflow-tooltip />
                <el-table-column prop="date" label="日期" align="center" width="140" show-overflow-tooltip />
                <el-table-column prop="weekday" label="星期" align="center" width="100" />
                <el-table-column prop="time" label="时间" align="center" width="140" show-overflow-tooltip />
                <el-table-column prop="courseName" label="课程名称" align="center" min-width="180" show-overflow-tooltip />
            </el-table>
            <!-- <pagination v-show="pages.total > 0" :total="pages.total" :page.sync="pages.currentPage"
                :limit.sync="pages.pageSize" :pageSizes="[10, 20, 30]" @pagination="handlePageChange" /> -->
        </div>
    </div>
</template>

<script>
    import { saveAs } from 'file-saver'

    export default {
        data() {
            return {
                loading: false,
                formInline: {
                    search: '',
                    spxId: '',
                },
                spaceOptions: [],
                allTableData: [],
                pages: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                },
            }
        },
        computed: {
            tableData() {
                const keyword = (this.formInline.search || '').trim().toLowerCase()
                if (!keyword) return this.allTableData
                return this.allTableData.filter(item => {
                    const spaceName = (item.spaceName || '').toLowerCase()
                    const courseName = (item.courseName || '').toLowerCase()
                    return spaceName.includes(keyword) || courseName.includes(keyword)
                })
            },
            // 相邻行日期+星期相同则合并，记录每行 rowspan（0 表示被合并隐藏）
            dateSpanArr() {
                const data = this.tableData
                const spanArr = []
                let pos = 0
                data.forEach((item, index) => {
                    if (index === 0) {
                        spanArr.push(1)
                        pos = 0
                        return
                    }
                    const prev = data[index - 1]
                    if (item.date === prev.date && item.weekday === prev.weekday) {
                        spanArr[pos] += 1
                        spanArr.push(0)
                    } else {
                        spanArr.push(1)
                        pos = index
                    }
                })
                return spanArr
            },
        },
        methods: {
            objectSpanMethod({ rowIndex, columnIndex }) {
                // 日期列、星期列
                if (columnIndex === 2 || columnIndex === 3) {
                    const rowspan = this.dateSpanArr[rowIndex]
                    return {
                        rowspan,
                        colspan: rowspan > 0 ? 1 : 0,
                    }
                }
            },
            indexMethod(index) {
                return this.pages.currentPage > 1
                    ? this.pages.pageSize * (this.pages.currentPage - 1) + index + 1
                    : index + 1
            },
            filterChange() {
                this.pages.currentPage = 1
                this.fetchList()
            },
            handlePageChange(data) {
                this.pages.currentPage = data.pageIndex
                this.pages.pageSize = data.pageSize
                this.fetchList()
            },
            async fetchSpaceOptions() {
                try {
                    const res = await this.$Api.Paired.getListByProject({
                        page: 1,
                        limit: 999,
                        projectId: this.$store.state.user.currentProject.id,
                    })
                    this.spaceOptions = (res.data && res.data.records) || []
                } catch (e) {
                    this.spaceOptions = []
                }
            },
            async fetchList() {
                this.loading = true
                try {
                    const res = await this.$Api.Paired.getCourseList({
                        projectId: this.$store.state.user.currentProject.id,
                        spaceIds: this.formInline.spxId
                            ? this.formInline.spxId
                            : this.spaceOptions.map(item => item.id).join(','),
                    })
                    this.allTableData = res.data || []
                    // this.pages.total = data.total || data.totalCount || 0
                } catch (e) {
                    this.allTableData = []
                    this.pages.total = 0
                } finally {
                    this.loading = false
                }
            },
            escapeCsv(value) {
                const str = value == null ? '' : String(value)
                if (/[",\n\r]/.test(str)) {
                    return `"${str.replace(/"/g, '""')}"`
                }
                return str
            },
            async exportExcelFile() {
                if (!this.tableData.length) {
                    this.$message.warning('暂无数据可导出')
                    return
                }
                const headers = ['序号', '空间名称', '日期', '星期', '时间', '课程名称']
                const rows = this.tableData.map((item, index) => [
                    this.indexMethod(index),
                    item.spaceName,
                    item.date,
                    item.weekday,
                    item.time,
                    item.courseName,
                ].map(this.escapeCsv).join(','))
                const csvContent = '\uFEFF' + [headers.join(','), ...rows].join('\n')
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
                saveAs(blob, `空间课程安排_${Date.now()}.csv`)
            },
            async exportWordFile() {
                const spaceIds = this.formInline.spxId
                    ? this.formInline.spxId
                    : this.spaceOptions.map(item => item.id).join(',')
                if (!spaceIds) {
                    this.$message.warning('暂无空间可导出')
                    return
                }
                try {
                    const blob = await this.$Api.Paired.exportCourseList({
                        projectId: this.$store.state.user.currentProject.id,
                        spaceIds,
                    })
                    saveAs(new Blob([blob], { type: 'application/zip' }), `空间课程安排_${Date.now()}.zip`)
                } catch (e) {
                    this.$message.error('导出失败，请稍后重试')
                }
            },
        },
        async mounted() {
            await this.fetchSpaceOptions()
            this.fetchList()
        },
    }
</script>

<style lang="less" scoped>
    // @import "../manage/less/table.less";

    .space-course {
        padding: 20px 25px;
        box-sizing: border-box;

        .demo-form-inline {
            width: 100%;
            margin: 15px 0;

            /deep/ .el-form-item {
                margin-bottom: 0;
            }
        }

        .table_section {
            margin-top: 10px;
        }
    }

    /deep/ .el-table {
        border-radius: 8px;
        border: 1px solid rgba(199, 199, 199, .43);
    }

    /deep/ .el-table__header {
        thead th {
            color: #000;
            font-weight: 400;
            background-color: RGBA(250, 251, 255, 1);
            border: 0;
        }
    }
</style>
